/* ============================================================
   Quill&Steel — Pricing plans interval toggle
   ------------------------------------------------------------
   Progressive enhancement only. The section renders its default
   interval server side and CSS hides the other one, so the page
   is complete and readable with this file blocked; all this does
   is let the reader switch.

   Both price blocks stay in the DOM the whole time. Toggling is
   one attribute write on the root, which keeps the two states
   the same height and avoids a reflow on click.
   ============================================================ */
(function () {
	function initPricingPlans(root) {
		if (root.dataset.ppReady === 'true') return;
		root.dataset.ppReady = 'true';

		var buttons = root.querySelectorAll('[data-pp-interval]');
		if (!buttons.length) return;

		function select(interval) {
			root.dataset.interval = interval;
			for (var i = 0; i < buttons.length; i++) {
				var btn = buttons[i];
				btn.setAttribute(
					'aria-pressed',
					btn.dataset.ppInterval === interval ? 'true' : 'false'
				);
			}
		}

		for (var i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', function (event) {
				select(event.currentTarget.dataset.ppInterval);
			});
		}
	}

	function initAll(scope) {
		var roots = (scope || document).querySelectorAll('[data-pricing-plans]');
		for (var i = 0; i < roots.length; i++) initPricingPlans(roots[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	} else {
		initAll();
	}

	// The theme editor swaps section markup in place without a page load, which
	// leaves the new copy uninitialised. Re-run against just that section.
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
